import XLSX from 'xlsx-js-style';
const headerStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
        top: { style: 'thin', color: { rgb: 'D0D5DD' } },
        bottom: { style: 'thin', color: { rgb: 'D0D5DD' } },
        left: { style: 'thin', color: { rgb: 'D0D5DD' } },
        right: { style: 'thin', color: { rgb: 'D0D5DD' } },
    }
};
const cellStyle = {
    font: { sz: 11, color: { rgb: '344054' } },
    alignment: { horizontal: 'left', vertical: 'center', wrapText: true },
    border: {
        top: { style: 'thin', color: { rgb: 'EAECF0' } },
        bottom: { style: 'thin', color: { rgb: 'EAECF0' } },
        left: { style: 'thin', color: { rgb: 'EAECF0' } },
        right: { style: 'thin', color: { rgb: 'EAECF0' } },
    }
};
const numberCellStyle = {
    ...cellStyle,
    alignment: { horizontal: 'right', vertical: 'center' },
};
export function exportPublisherArticles(rows, domain) {
    if (!rows || rows.length === 0) {
        return false;
    }
    const headers = ['Client Name', 'Search Term', 'Domain', 'Article Visitors', 'Article'];
    const colWidths = [20, 35, 25, 16, 60];
    const sheetData = [
        headers.map((h, i) => ({ v: h, s: headerStyle })),
        ...rows.map(r => [
            { v: r.client_name || '', s: cellStyle },
            { v: r.search_term || '', s: cellStyle },
            { v: r.domain || '', s: cellStyle },
            { v: r.article_visitors || 0, t: 'n', s: numberCellStyle },
            { v: r.article || '', s: cellStyle },
        ])
    ];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!cols'] = colWidths.map(w => ({ wch: w }));
    ws['!rows'] = sheetData.map(() => ({ hpt: 20 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Publisher Articles');
    const safeDate = new Date().toISOString().slice(0, 10);
    const safeDomain = domain.replace(/[^a-zA-Z0-9._-]/g, '_');
    XLSX.writeFile(wb, `Publisher_Articles_${safeDomain}_${safeDate}.xlsx`);
    return true;
}
